export default __webpack_public_path__ + "static/media/img-7-earned-new-mobile.8d29da88.png";